import { useState } from "react";
import type { FormEvent } from "react";
import { categories } from "@/mocks/topics";

interface FilterBarProps {
  active: string;
  keyword: string;
  sort: string;
  onCategory: (value: string) => void;
  onKeyword: (value: string) => void;
  onSort: (value: string) => void;
}

const sorts = [
  { value: "heat", label: "按热度" },
  { value: "latest", label: "按最新" },
];

export default function FilterBar({
  active,
  keyword,
  sort,
  onCategory,
  onKeyword,
  onSort,
}: FilterBarProps) {
  const [draft, setDraft] = useState(keyword);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    onKeyword(draft.trim());
  };

  return (
    <div className="w-full rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <form onSubmit={submit} className="relative w-full lg:max-w-md">
          <span className="pointer-events-none absolute left-4 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-base"></i>
          </span>
          <input
            type="text"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="搜索事件标题或关键词"
            aria-label="搜索事件"
            className="w-full rounded-md border border-background-300 bg-background-50 py-2.5 pl-11 pr-24 font-label text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
          />
          <button
            type="submit"
            className="absolute right-1.5 top-1/2 flex -translate-y-1/2 items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-1.5 font-label text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <div className="flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {sorts.map((s) => (
            <button
              key={s.value}
              type="button"
              onClick={() => onSort(s.value)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 font-label text-xs transition-colors ${
                sort === s.value
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-background-200 pt-4">
        {categories.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => onCategory(c)}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 font-label text-xs transition-colors ${
              active === c
                ? "bg-secondary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-secondary-300 hover:bg-secondary-50"
            }`}
          >
            {c}
          </button>
        ))}
      </div>
    </div>
  );
}